import { Navigate, Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingMembershipFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { SessionDetail } from 'modules/trainings/components/MyTrainings/SessionDetail'
import { useTrainingsContext } from 'modules/trainings/hooks/Trainings/useTrainingsContext'

const EmployeeSessionModal = () => {
  const { trainingId, sessionId } = useParams()
  const { employeeId, employeeAccessId, trainingMemberships } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    trainingMemberships: TrainingMembershipFragment[]
  }>()
  const { navigation } = useNavigation()
  const { trainings } = useTrainingsContext()
  const training = trainings.find((t) => t.id === Number(trainingId))
  const session = training?.sessions.find((s) => s.id === Number(sessionId))

  if (!session || !training)
    return (
      <Navigate
        replace
        to={navigation.employees.id.training.detail.view.fullPath({
          id: String(employeeId),
          trainingId: String(trainingId),
        })}
      />
    )

  return (
    <>
      <Outlet
        context={{
          employeeId,
          employeeAccessId,
          trainingId,
          session,
          trainingMemberships,
        }}
      />
      <SessionDetail
        training={training}
        session={session}
        title={session.name}
        certificatesModalPath={navigation.employees.id.training.detail.view.sessionDetail.certificates.upload.fullPath(
          {
            id: String(employeeId),
            trainingId: String(trainingId),
            sessionId: String(session.id),
          }
        )}
        to={navigation.employees.id.training.detail.view.fullPath({
          id: String(employeeId),
          trainingId: String(trainingId),
        })}
      />
    </>
  )
}

export default EmployeeSessionModal
